<template>
    <div>
        <nav class="navbar navbar-default probootstrap-navbar">
            <div class="container">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                        data-target="#navbar-collapse" aria-expanded="false" aria-controls="navbar">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand" href="/home">
                        <img class="logoIcon" src="../assets/common/logo.png" alt="">
                    </a>
                </div>
                <div id="navbar-collapse" class="navbar-collapse collapse">
                    <ul class="nav navbar-nav navbar-right">
                        <li :class="[navIndex === 1 ? 'active' : '']"><a href="/home" class="navName">首页</a></li>
                        <li :class="[navIndex === 5 ? 'active' : '']"><a href="/mall" class="navName">心泰商城</a></li>
                        <li class="navTool" :class="[navIndex === 2 ? 'active' : '']" @mouseenter="showTab = true"
                            @mouseleave="showTab = false">
                            <a href="/wear" class="navName">产品与合作</a>
                            <div class="navToolTab" v-show="showTab">
                                <p><a href="/wear">智能设备</a></p>
                                <p><a href="/algorithm">健康算法</a></p>
                                <p><a href="/system">健康系统</a></p>
                                <p><a href="/extension">科学学术</a></p>
                            </div>
                        </li>
                        <li :class="[navIndex === 4 ? 'active' : '']"><a href="/extension" class="navName">301医院健康研究</a></li>
                        <li :class="[navIndex === 3 ? 'active' : '']"><a href="/about" class="navName">关于我们</a></li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: "navBar",
    data() {
        return {
            showTab: false,
            navIndex: 1
        }
    },
    mounted() {
        let pathname = window.location.pathname;
        if (pathname.indexOf('home') !== -1) {
            this.navIndex = 1;
        } else if (pathname.indexOf('system') !== -1 || pathname.indexOf('wear') !== -1 || pathname.indexOf('algorithm') !== -1) {
            this.navIndex = 2;
        } else if (pathname.indexOf('about') !== -1) {
            this.navIndex = 3;
        } else if (pathname.indexOf('extension') !== -1) {
            this.navIndex = 4;
        } else if (pathname.indexOf('mall') !== -1) {
            this.navIndex = 5;
        } else {
            this.navIndex = 1;
        }
        window.addEventListener("scroll", this.scrolling);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.scrolling);
    },
    methods: {
        scrolling() {
            this.showTab = false
            // 滚动条距文档顶部的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            let el = document.getElementsByClassName('probootstrap-navbar')[0];
            let fixed = window.sessionStorage.getItem('fixed')=='true'?true:false
            let navName=document.getElementsByClassName('navName')[0]
            let navName1=document.getElementsByClassName('navName')[1]
            let navName2=document.getElementsByClassName('navName')[2]
            let navName3=document.getElementsByClassName('navName')[3]
            let navName4=document.getElementsByClassName('navName')[4]
            if (scrollTop > 100) {
                if (fixed) {
                    el.style.background = 'rgba(243, 245, 250, 0.55)';
                    el.style.backdropFilter = 'blur(3px)';
                    navName.style.color='rgb(102 102 102)';
                    navName1.style.color='rgb(102 102 102)';
                    navName2.style.color='rgb(102 102 102)';
                    navName3.style.color='rgb(102 102 102)';
                    navName4.style.color='rgb(102 102 102)';
                } else {
                    el.style.background = 'rgba(0,0,0,.5)';
                    el.style.backdropFilter = 'blur(0px)';
                    navName.style.color='rgba(255, 255, 255, 0.7)'
                    navName1.style.color='rgba(255, 255, 255, 0.7)';
                    navName2.style.color='rgba(255, 255, 255, 0.7)';
                    navName3.style.color='rgba(255, 255, 255, 0.7)';
                    navName4.style.color='rgba(255, 255, 255, 0.7)';
                }
            } else {
                el.style.background = 'transparent';
                el.style.backdropFilter = 'blur(0px)';
                navName.style.color='rgba(255, 255, 255, 0.7)'
                navName1.style.color='rgba(255, 255, 255, 0.7)';
                navName2.style.color='rgba(255, 255, 255, 0.7)';
                navName3.style.color='rgba(255, 255, 255, 0.7)';
                navName4.style.color='rgba(255, 255, 255, 0.7)';
            }
        },
    }
}
</script>

<style scoped>
@import "../assets/css/styles-merged.css";
@import "../assets/css/style.min.css";

.navTool {
    position: relative;
}

.navToolTab {
    position: absolute;
    top: 68px;
    left: 5.5%;
    z-index: 0;
    background: #ffffff;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0px 0px 29px 0px rgb(120 132 142 / 50%);

}

.navToolTab:before {
    content: '';
    width: 0;
    height: 0;
    border: 12px solid;
    border-radius: 10px;
    position: absolute;
    top: -20px;
    transform: rotate(180deg);
    left: 40%;
    border-color: #fff transparent transparent;
}

.navToolTab p {
    padding: 5px 30px;
    margin: 0;
    border-bottom: 1px solid rgba(204, 204, 204, 1);
}

.navToolTab p:last-child {
    border-bottom: none;
}

.navToolTab p a {
    color: #000000 !important;
    font-size: 15px !important;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 21px !important;

}

.logoIcon,
.zh_enIcon {
    /*width: 93px;*/
    height: 30px;
}

.lineL::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 1px;
    height: 30px;
    background: rgba(255, 255, 255, 0.7);
}

/* @media (max-width: 1200px) {
        .navbar-toggle {
            display: block
        }
        .lineL::before{
            width: 0!important;
        }
    } */</style>
